/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require("./components/vue-declarator");

let app = document.getElementById("app");
if (app) {
    const app = new Vue({
        el: "#app"
    });
}

require("./global");



// WEBPACK FOOTER //
// ./resources/js/app.js